<app-stats-card *ngFor="let status of statusCards" [label]="status.label" [count]="status.count"></app-stats-card>